import { GameConstants } from './../../../../GameConstants';
import { BattleManager } from "./../../BattleManager";
import { UpgradeButton } from "./UpgradeButton";
import { SellButton } from "./SellButton";
import { GameVars } from "../../../../GameVars";

import * as Anuto from "../../../../../engine/src";

export class UpgradeTurretMenu extends Phaser.GameObjects.Container {

    public anutoTurret: Anuto.Turret;
    public sellButton: SellButton;
    public upgradeButton: UpgradeButton;

    private f: number;

    constructor(scene: Phaser.Scene) {

        super(scene);

        this.f = -1;

        let background = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "area_compra");
        this.add(background);

        this.upgradeButton = new UpgradeButton(this.scene, 0, -67);
        this.add(this.upgradeButton);

        this.sellButton = new SellButton(this.scene, 0, 67);
        this.add(this.sellButton);

        this.visible = false;

        if (!this.scene.sys.game.device.os.desktop) {
            this.setScale(1 + (GameVars.aspectRatio - (4 / 3)) * .5);
            this.scaleX *= (1 / (GameVars.scaleX + GameVars.contrascaleX)) * GameVars.scaleX;
        }

        this.scene.sys.updateList.add(this);
    }

    public preUpdate(time: number, delta: number): void {

        if (this.f !== -1) {
            this.f++;
            if (this.f === 120) {
                this.hide(true);
            }
        }
    }

    public show(anutoTurret: Anuto.Turret): void {

        this.f = 0;

        this.anutoTurret = anutoTurret;
        this.visible = true;

        this.sellButton.updateInfo(anutoTurret);
        this.upgradeButton.updateInfo(anutoTurret);
    }

    public hide(checkPosition?: boolean): void {

        if (checkPosition && this.scene.sys.game.device.os.desktop) {

            let x = this.x + GameConstants.GAME_WIDTH / 2;
            if (x - 100 < this.scene.input.activePointer.x && x + 100 > this.scene.input.activePointer.x) {
                if (this.y - 100 < this.scene.input.activePointer.y && this.y + 100 > this.scene.input.activePointer.y) {
                    this.f = 0;
                    return;
                }
            }
        }

        this.f = -1;

        BattleManager.hideRangeCircles();

        this.scene.tweens.add({
            targets: this,
            alpha: 0,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 100,
            onComplete: () => {
                this.visible = false;
                this.alpha = 1;
            },
            onCompleteScope: this
        });
    }
}